import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOneClick } from '../../../contexts/OneClickBuyContext';
import Clipboard from '../../Clipboard';
import { BsCheck2Circle } from 'react-icons/bs';
import { MdOutlineContentCopy } from 'react-icons/md';
import { CopyIcon, CopyTarget, TransactionDetailsContainer } from './TransactionDetailsContainer';

const resolveOrderCode = (order: { hash?: string | null; id?: number | string | null }) => {
	const code = typeof order?.hash === 'string' ? order.hash.trim() : '';
	if (code) {
		return { display: code, copyValue: code };
	}
	if (order?.id == null || order.id === '') {
		return { display: '', copyValue: '' };
	}
	return {
		display: `#${String(order.id).padStart(8, '0')}`,
		copyValue: String(order.id),
	};
};

const TransactionDetails: React.FC = () => {
	const { t } = useTranslation('upsell');
	const { paymentResponse, actualTransaction } = useOneClick();
	const [clipboard, setClipboard] = useState({
		value: '',
		copied: false,
	});
	const { display: orderCodeDisplay, copyValue: orderCodeCopyValue } = resolveOrderCode(paymentResponse);

	return (
		<TransactionDetailsContainer>
			<p>
				<b>{String(t('transactionDetails.product'))} </b> {paymentResponse.items[0].product.name}
			</p>
			<p>
				<b>{String(t('transactionDetails.orderHash'))} </b>
				{orderCodeCopyValue ? (
					<Clipboard text={orderCodeCopyValue} clipboard={clipboard} setClipboard={setClipboard}>
						<CopyTarget>
							{orderCodeDisplay}
							<CopyIcon aria-hidden='true'>
								{clipboard.copied ? <BsCheck2Circle /> : <MdOutlineContentCopy />}
							</CopyIcon>
						</CopyTarget>
					</Clipboard>
				) : null}
			</p>
			<p>
				<b>{String(t('transactionDetails.transactionHash'))} </b>
				<span>{actualTransaction.hash}</span>
			</p>
		</TransactionDetailsContainer>
	);
};

export default TransactionDetails;
